import {ACCOUNT_CACHE_KEY, GetObjectProperty, SetObjectPropertyValueRecursively} from "@/utils/local-storage";

export function GetAccountDefaults() {
	return {
		lastSelectedProjectId: 0
	};
}

export function UpdateAccountProperty(id, path, value) {
	const data = GetData(id, ACCOUNT_CACHE_KEY, GetAccountDefaults());
	const updatedData = SetObjectPropertyValueRecursively(data, path.split('.'), value);
	SetData(id, updatedData, ACCOUNT_CACHE_KEY);
}

export function GetAccountProperty(id, path, def) {
	const accountData = GetData(id, ACCOUNT_CACHE_KEY);

	if (accountData === undefined) {
		return def;
	}

	const propValue = GetObjectProperty(accountData, path.split('.'));

	return propValue === undefined ? def : propValue;
}


function GetData(id, cacheKey, def) {
	const cacheString = sessionStorage.getItem(cacheKey);

	if (null === cacheString) {
		return def;
	}

	const cache = JSON.parse(cacheString);

	return cache[id] !== undefined
		? cache[id]
		: def
}

function SetData(id, data, cacheKey) {
	const cacheString = sessionStorage.getItem(cacheKey);

	if (null === cacheString) {
		sessionStorage.setItem(
			cacheKey,
			JSON.stringify({ [id]: data })
		);
		return;
	}

	const cache = JSON.parse(cacheString);

	cache[id] = data;

	sessionStorage.setItem(
		cacheKey,
		JSON.stringify(cache)
	);
}
